import { AppCopyText } from "components/ui";
import { useRef } from "react";

type UserDiagnosticsCopyButtonProps = {
    localization: string;
    text: string;
};

export const UserDiagnosticsCopyButton = ({
    localization,
    text
}: UserDiagnosticsCopyButtonProps) => {
    const wrapperRef = useRef<HTMLDivElement>(null);

    //Without altering the AppCopyText, this is a way to simulate a click on the child
    const handleParentClick = () => {
        if (wrapperRef.current) {
            const clickable = wrapperRef.current.querySelector('button');

            if (clickable instanceof HTMLElement) {
                clickable.click();
            }
            else {
                console.warn("No clickable element found.");
            }
        }
    };

    return (
        <div
            ref={wrapperRef}
            className='btn border-secondary btn-secondary font-oswald font-13 font-500 d-flex align-items-center justify-content-center text-uppercase'
            onClick={handleParentClick}
        >
            <p className='mb-0 overflow-ellipsis' title={localization}>
                {localization}
            </p>
            <AppCopyText className='ml-1' text={text} />
        </div>
    );
};

export default UserDiagnosticsCopyButton;